<form [formGroup]="formGroup">
  <div id="searchByAutocomplete" class="column twelve lg-twelve">
    <div class="column twelve pad-bottom-5">
      <ds-form-control-container
        [labelText]="'Search'"
        [inputWrapperClass]="'input flex'"
        [control]="formGroup.controls['searchValue']"
      >
        <input
          data-cy="drpSearchByAutocompleteInput"
          type="text"
          id="search-value"
          class="fill"
          formControlName="searchValue"
          required
          autocomplete="off"
        />
        <button
          data-cy="drpSearchByAutocompleteButton"
          ds-button
          class="search-icon"
          [disabled]="isPredicting"
          (click)="searchSubmit(formGroup.controls['searchValue'].value)"
        >
          <span class="icon-search"></span>
        </button>

        <ds-form-control-message [control]="formGroup.controls['searchValue']">
        </ds-form-control-message>
      </ds-form-control-container>

      <div class="column twelve pad-bottom-5">
        <drp-autofill-dropdown
          data-cy="drpSearchByAutocompleteDropdown"
          [suggestionsClass]="'autocomplete-suggestions show-suggestions'"
          [addressGuesses]="predictions"
          (userSelectedAddress)="onPredictionSelect($event)"
        ></drp-autofill-dropdown>
      </div>
    </div>
  </div>
</form>
